export default "__VITE_ASSET__ChrljWV8__"